import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import api, { apiError } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Store, User, KeyRound, Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const doLogin = async (u, p) => {
    setLoading(true);
    try {
      const user = await login(u, p);
      toast.success(`Selamat datang, ${user.name}`);
      navigate(user.role === "kasir" ? "/pos" : "/dashboard");
    } catch (e) {
      toast.error(apiError(e.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      {/* Left brand */}
      <div className="hidden lg:flex flex-col justify-between bg-slate-900 p-12 relative overflow-hidden">
        <div className="absolute inset-0 opacity-10"
          style={{ backgroundImage: "url('https://images.unsplash.com/photo-1759200165738-6366977a73c6?crop=entropy&cs=srgb&fm=jpg&w=1200&q=80')", backgroundSize: "cover", backgroundPosition: "center" }} />
        <div className="relative flex items-center gap-3">
          <div className="h-12 w-12 rounded-xl bg-orange-500 flex items-center justify-center">
            <Store className="h-6 w-6 text-white" />
          </div>
          <div>
            <div className="text-white font-bold text-xl font-display">Sumber Harapan</div>
            <div className="text-slate-400 text-sm">Toko Bangunan · Bitung</div>
          </div>
        </div>
        <div className="relative">
          <h1 className="text-white text-4xl font-extrabold font-display leading-tight tracking-tight">
            Sistem Point of Sale<br /><span className="text-orange-500">Toko Bangunan</span>
          </h1>
          <p className="text-slate-400 mt-4 max-w-md">
            Kelola kasir, stok, pembelian, keuangan, dan laporan dalam satu platform terintegrasi.
          </p>
        </div>
        <div className="relative text-slate-500 text-xs">© 2026 Sumber Harapan Bitung</div>
      </div>

      {/* Right form */}
      <div className="flex items-center justify-center p-6 bg-slate-100">
        <div className="w-full max-w-sm">
          <div className="lg:hidden flex items-center gap-3 mb-8 justify-center">
            <div className="h-11 w-11 rounded-xl bg-orange-500 flex items-center justify-center">
              <Store className="h-5 w-5 text-white" />
            </div>
            <div className="font-bold text-lg font-display">Sumber Harapan</div>
          </div>
          <h2 className="text-2xl font-bold font-display text-slate-900">Masuk ke Sistem</h2>
          <p className="text-slate-500 text-sm mt-1 mb-6">Gunakan username dan password Anda</p>

          <form onSubmit={(e) => { e.preventDefault(); doLogin(username, password); }} className="space-y-4">
            <div className="space-y-1.5">
              <Label>Username</Label>
              <div className="relative">
                <User className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-slate-400" />
                <Input value={username} onChange={(e) => setUsername(e.target.value)}
                  placeholder="username" className="pl-9" data-testid="login-username-input" />
              </div>
            </div>
            <div className="space-y-1.5">
              <Label>Password</Label>
              <div className="relative">
                <KeyRound className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-slate-400" />
                <Input type="password" value={password} onChange={(e) => setPassword(e.target.value)}
                  placeholder="••••••••" className="pl-9" data-testid="login-password-input" />
              </div>
            </div>
            <Button type="submit" disabled={loading}
              className="w-full h-11 bg-orange-500 hover:bg-orange-600 font-semibold"
              data-testid="login-submit-button">
              {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Masuk"}
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
}
